// First Created - 01 Jul 2026
// Author - Atul Pandey
// Purpose - Route page wrapper for a user's Trail Board.

import React from 'react'
import { useParams } from 'react-router-dom'

import EtUserTrailBoardCompProd from '@/features/userTrailBoards/EtUserTrailBoardCompProd'

const EtUserTrailBoardPage = () => {
  const { userId, trailId } = useParams()

  return (
    <EtUserTrailBoardCompProd
      userId={userId}
      trailId={trailId}
    />
  )
}

export default EtUserTrailBoardPage